import type { Language } from './types';

const translations = {
  he: {
    appName: 'TraderYo',
    calendar: 'לוח שנה',
    trades: 'עסקאות',
    reports: 'דוחות',
    settings: 'הגדרות',
    playbook: 'פלייבוק',
    newSetup: 'סטאפ חדש',
    editSetup: 'ערוך סטאפ',
    searchSetups: 'חפש סטאפים…',
    allSetups: 'הכל',
    activeSetups: 'פעיל',
    archivedSetups: 'בארכיון',
    noSetups: 'אין סטאפים עדיין — צור אחד כדי להתחיל',
    noActiveSetups: 'אין סטאפים פעילים — צור אחד בפלייבוק',
    confirmAndLog: 'אשר ורשום עסקה',
    skipChecklist: 'דלג על רשימת הבדיקה',
    useSuggestion: 'השתמש בהמלצה',
    selectSetup: 'בחר סטאפ',
    changeSetup: '← שנה סטאפ',
    allChecksPassed: 'כל הבדיקות עברו',
    almostThere: 'כמעט שם',
    headsUpIncomplete: 'שים לב — לא הושלם',
    selectASetup: 'בחר סטאפ',
    noRulesYet: 'אין חוקים עדיין',
    activeVisible: 'פעיל (גלוי ברשימת הבדיקה)',
    deleteSetupConfirm: 'למחוק סטאפ זה?',
    backToJournal: 'חזרה ליומן',
    tradeNotFound: 'עסקה לא נמצאה',
    chartUnavailable: 'גרף לא זמין',
    paused: 'מושהה',
    openFullReplay: '← פתח ריפליי מלא',
    whatToLearn: 'מה ללמוד',
    eventTimeline: 'ציר זמן אירועים',
    newTrade: 'עסקה חדשה',
    editTrade: 'ערוך עסקה',
    addTrade: 'הוסף עסקה',
    saveTrade: 'שמור עסקה',
    deleteTrade: 'מחק עסקה',
    cancel: 'ביטול',
    save: 'שמור',
    delete: 'מחק',
    edit: 'ערוך',
    close: 'סגור',
    allAccounts: 'כל החשבונות',
    addAccount: 'הוסף חשבון',
    editAccount: 'ערוך חשבון',
    accountName: 'שם החשבון',
    accountType: 'סוג חשבון',
    personal: 'לייב',
    propFirm: 'תיק ממומן',
    demo: 'תיק מבחן',
    broker: 'ברוקר',
    manual: 'ידני',
    initialBalance: 'יתרה התחלתית',
    currency: 'מטבע',
    totalPnL: 'רווח/הפסד כולל',
    winRate: 'אחוז זכייה',
    totalTrades: 'סה"כ עסקאות',
    avgWin: 'ממוצע רווח',
    avgLoss: 'ממוצע הפסד',
    profitFactor: 'פקטור רווח',
    date: 'תאריך',
    entry: 'כניסה',
    exit: 'יציאה',
    symbol: 'סמל',
    direction: 'כיוון',
    long: 'קניה',
    short: 'מכירה',
    pnl: 'רווח/הפסד',
    size: 'גודל (חוזים)',
    stopLoss: 'עצור הפסד (נקודות)',
    takeProfit: 'מטרת רווח (נקודות)',
    strategy: 'אסטרטגיה',
    account: 'חשבון',
    confirmations: 'אישורים',
    htfPdArray: 'HTF PD Array',
    psychology: 'פסיכולוגיה',
    notes: 'הערות',
    media: 'צילומי מסך',
    dragDrop: 'גרור ושחרר צילומי מסך מ-TradingView',
    clickUpload: 'או לחץ להעלאה',
    profit: 'רווח',
    loss: 'הפסד',
    today: 'היום',
    more: 'עוד',
    noTrades: 'אין עסקאות',
    noTradesDesc: 'לחץ על תאריך בלוח השנה כדי להוסיף עסקה',
    strategies: 'אסטרטגיות',
    addStrategy: 'הוסף אסטרטגיה',
    strategyName: 'שם אסטרטגיה',
    color: 'צבע',
    brokerConnections: 'חיבורי ברוקר',
    connected: 'מחובר',
    connect: 'התחבר',
    disconnect: 'התנתק',
    lastSync: 'סנכרון אחרון',
    syncNow: 'סנכרן עכשיו',
    exportPDF: 'ייצא PDF',
    exportCSV: 'ייצא CSV/Excel',
    dateRange: 'טווח תאריכים',
    from: 'מ',
    to: 'עד',
    allTime: 'כל הזמן',
    thisMonth: 'החודש',
    thisWeek: 'השבוע',
    generateReport: 'צור דוח',
    accessibility: 'נגישות',
    fontSize: 'גודל טקסט',
    highContrast: 'ניגודיות גבוהה',
    grayscale: 'גווני אפור',
    readableFont: 'גופן קריא',
    loginWith: 'כניסה עם',
    google: 'Google',
    apple: 'Apple',
    orContinueWith: 'או המשך בתור',
    demoMode: 'מצב הדגמה (ללא חשבון)',
    welcomeBack: 'ברוך הבא',
    loginSubtitle: 'יומן מסחר מקצועי',
    emailLabel: 'אימייל',
    passwordLabel: 'סיסמא',
    signIn: 'כניסה',
    signUp: 'הרשמה',
    forgotPassword: 'שכחתי סיסמא',
    noAccount: 'אין לך חשבון?',
    hasAccount: 'כבר יש לך חשבון?',
    resetSent: 'נשלח אימייל לאיפוס סיסמא',
    checkEmail: 'בדוק את תיבת הדואר שלך לאישור',
    disclaimer:
      '⚠ המידע המוצג אינו ייעוץ השקעות. מסחר בניירות ערך כרוך בסיכון אובדן הון. אנא התייעצו עם יועץ פיננסי מוסמך לפני קבלת כל החלטת השקעה.',
    terms: 'תנאי שימוש',
    privacy: 'מדיניות פרטיות',
    searchSymbol: 'חפש סמל...',
    filterBy: 'סנן לפי',
    allDirections: 'כל הכיוונים',
    allStrategies: 'כל האסטרטגיות',
    sortBy: 'מיין לפי',
    months: [
      'ינואר',
      'פברואר',
      'מרץ',
      'אפריל',
      'מאי',
      'יוני',
      'יולי',
      'אוגוסט',
      'ספטמבר',
      'אוקטובר',
      'נובמבר',
      'דצמבר',
    ],
    days: ["א'", "ב'", "ג'", "ד'", "ה'", "ו'", "ש'"],
    confirmDelete: 'האם אתה בטוח שברצונך למחוק?',
    fields: 'שדות',
    addField: 'הוסף שדה',
    fieldLabel: 'תווית',
    fieldType: 'סוג שדה',
    checkbox: 'תיבת סימון',
    text: 'טקסט',
    logout: 'התנתק',
    profile: 'פרופיל',
    dailyGoals: 'יעדים יומיים',
    dailyGoalTarget: 'יעד רווח יומי ($)',
    dailyMaxLoss: 'גבול הפסד יומי ($)',
    dailyGoalHint: 'הגדר 0 כדי להשבית',
    todayPnL: 'רווח/הפסד היום',
    goalReached: 'יעד הושג!',
    maxLossHit: 'גבול הפסד!',
    noGoalSet: 'לא הוגדר יעד יומי',
    setGoalPrompt: 'הגדר יעדים בהגדרות',
    thisQuarter: 'הרבעון',
    bestTrade: 'עסקה מובילה',
    worstTrade: 'עסקה גרועה',
    byStrategy: 'לפי אסטרטגיה',
    bySymbol: 'לפי סמל',
    count: 'כמות',
  },
  en: {
    appName: 'TraderYo',
    calendar: 'Calendar',
    trades: 'Trades',
    reports: 'Reports',
    settings: 'Settings',
    playbook: 'Playbook',
    newSetup: 'New setup',
    editSetup: 'Edit setup',
    searchSetups: 'Search setups…',
    allSetups: 'All',
    activeSetups: 'Active',
    archivedSetups: 'Archived',
    noSetups: 'No setups yet — create one to get started',
    noActiveSetups: 'No active setups — create one in Playbook',
    confirmAndLog: 'Confirm & log trade',
    skipChecklist: 'Skip checklist',
    useSuggestion: 'Use suggestion',
    selectSetup: 'SELECT SETUP',
    changeSetup: '← Change setup',
    allChecksPassed: 'All checks passed',
    almostThere: 'Almost there',
    headsUpIncomplete: 'Heads up — incomplete',
    selectASetup: 'Select a setup',
    noRulesYet: 'No rules yet',
    activeVisible: 'Active (visible in checklist)',
    deleteSetupConfirm: 'Delete this setup?',
    backToJournal: 'Back to Journal',
    tradeNotFound: 'Trade not found',
    chartUnavailable: 'Chart unavailable',
    paused: 'PAUSED',
    openFullReplay: 'Open full replay →',
    whatToLearn: 'WHAT TO LEARN',
    eventTimeline: 'EVENT TIMELINE',
    newTrade: 'New Trade',
    editTrade: 'Edit Trade',
    addTrade: 'Add Trade',
    saveTrade: 'Save Trade',
    deleteTrade: 'Delete Trade',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    allAccounts: 'All Accounts',
    addAccount: 'Add Account',
    editAccount: 'Edit Account',
    accountName: 'Account Name',
    accountType: 'Account Type',
    personal: 'Live',
    propFirm: 'Funded',
    demo: 'Eval',
    broker: 'Broker',
    manual: 'Manual',
    initialBalance: 'Initial Balance',
    currency: 'Currency',
    totalPnL: 'Total P&L',
    winRate: 'Win Rate',
    totalTrades: 'Total Trades',
    avgWin: 'Avg Win',
    avgLoss: 'Avg Loss',
    profitFactor: 'Profit Factor',
    date: 'Date',
    entry: 'Entry',
    exit: 'Exit',
    symbol: 'Symbol',
    direction: 'Direction',
    long: 'Long',
    short: 'Short',
    pnl: 'P&L',
    size: 'Size (contracts)',
    stopLoss: 'Stop Loss (pts)',
    takeProfit: 'Take Profit (pts)',
    strategy: 'Strategy',
    account: 'Account',
    confirmations: 'Confirmations',
    htfPdArray: 'HTF PD Array',
    psychology: 'Psychology',
    notes: 'Notes',
    media: 'Screenshots',
    dragDrop: 'Drag & drop TradingView screenshots here',
    clickUpload: 'or click to upload',
    profit: 'Profit',
    loss: 'Loss',
    today: 'Today',
    more: 'more',
    noTrades: 'No trades yet',
    noTradesDesc: 'Click a date on the calendar to add a trade',
    strategies: 'Strategies',
    addStrategy: 'Add Strategy',
    strategyName: 'Strategy Name',
    color: 'Color',
    brokerConnections: 'Broker Connections',
    connected: 'Connected',
    connect: 'Connect',
    disconnect: 'Disconnect',
    lastSync: 'Last sync',
    syncNow: 'Sync now',
    exportPDF: 'Export PDF',
    exportCSV: 'Export CSV/Excel',
    dateRange: 'Date Range',
    from: 'From',
    to: 'To',
    allTime: 'All Time',
    thisMonth: 'This Month',
    thisWeek: 'This Week',
    generateReport: 'Generate Report',
    accessibility: 'Accessibility',
    fontSize: 'Font Size',
    highContrast: 'High Contrast',
    grayscale: 'Grayscale',
    readableFont: 'Readable Font',
    loginWith: 'Continue with',
    google: 'Google',
    apple: 'Apple',
    orContinueWith: 'or continue as',
    demoMode: 'Demo Mode (no account)',
    welcomeBack: 'Welcome back',
    loginSubtitle: 'Professional Trading Journal',
    emailLabel: 'Email',
    passwordLabel: 'Password',
    signIn: 'Sign In',
    signUp: 'Sign Up',
    forgotPassword: 'Forgot password?',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    resetSent: 'Password reset email sent',
    checkEmail: 'Check your inbox to confirm',
    disclaimer:
      '⚠ Information displayed is not investment advice. Trading involves significant risk of capital loss. Please consult a licensed financial advisor before making any investment decisions.',
    terms: 'Terms of Use',
    privacy: 'Privacy Policy',
    searchSymbol: 'Search symbol...',
    filterBy: 'Filter by',
    allDirections: 'All Directions',
    allStrategies: 'All Strategies',
    sortBy: 'Sort by',
    months: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    confirmDelete: 'Are you sure you want to delete this?',
    fields: 'Fields',
    addField: 'Add Field',
    fieldLabel: 'Label',
    fieldType: 'Field Type',
    checkbox: 'Checkbox',
    text: 'Text',
    logout: 'Log out',
    profile: 'Profile',
    dailyGoals: 'Daily Goals',
    dailyGoalTarget: 'Daily Profit Target ($)',
    dailyMaxLoss: 'Daily Max Loss ($)',
    dailyGoalHint: 'Set 0 to disable',
    todayPnL: "Today's P&L",
    goalReached: 'Goal reached!',
    maxLossHit: 'Max loss hit!',
    noGoalSet: 'No daily goal set',
    setGoalPrompt: 'Set goals in Settings',
    thisQuarter: 'This Quarter',
    bestTrade: 'Best Trade',
    worstTrade: 'Worst Trade',
    byStrategy: 'By Strategy',
    bySymbol: 'By Symbol',
    count: 'Count',
  },
} as const;

export type TKeys = keyof typeof translations.he;
export type Translations = typeof translations.he;

export function useT(lang: Language) {
  return translations[lang] as Translations;
}

export function t(lang: Language, key: TKeys): string {
  const val = (translations[lang] as Record<string, unknown>)[key];
  if (typeof val === 'string') return val;
  return key;
}
